module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticfilesystem-2015-02-01.paginators.json
// module id = 355
// module chunks = 1